import React, {useCallback} from "react";
import "./CreditCardLogo.scss";
import MasterCardLogo from "../../../assets/images/mastercard-logo.png";
import VisaCardLogo from "../../../assets/images/visa-logo.png";
import AmexCardLogo from "../../../assets/images/amex-logo.png";

interface CreditCardLogoProps {
    creditCard: string;
}

export const CreditCardLogo: React.FunctionComponent<CreditCardLogoProps> = (props) => {
    const VISA_CREDIT_CARD_REGEX = /^4[0-9]{6,}$/;
    const MASTER_CARD_CREDIT_CARD_REGEX = /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/;
    const AMEX_CREDIT_CARD_REGEX = /^3[47][0-9]{5,}$/;

    const isMasterCardLogoVisible = useCallback(() => {
        return MASTER_CARD_CREDIT_CARD_REGEX.test(props.creditCard);
    }, [props.creditCard]);

    const isVisaLogoVisible = useCallback(() => {
        return VISA_CREDIT_CARD_REGEX.test(props.creditCard);
    }, [props.creditCard]);

    const isAmexLogoVisible = useCallback(() => {
        return AMEX_CREDIT_CARD_REGEX.test(props.creditCard);
    }, [props.creditCard]);

    const isLogoVisible = useCallback(() => {
        return isMasterCardLogoVisible() || isVisaLogoVisible() || isAmexLogoVisible();
    }, [props.creditCard, isMasterCardLogoVisible, isVisaLogoVisible, isAmexLogoVisible]);

    return <>{isLogoVisible() ? <div className="credit-card-logo-container">
        {isMasterCardLogoVisible() ?
            <img className="credit-card-logo master-card-logo" src={MasterCardLogo}/> : null}
        {isVisaLogoVisible() ?
            <img className="credit-card-logo visa-logo" src={VisaCardLogo}/> : null}
        {isAmexLogoVisible() ?
            <img className="credit-card-logo amex-logo" src={AmexCardLogo}/> : null}
    </div> : null}</>
}
